import React from "react";
import PropTypes from 'prop-types';
import StatusSelect from "./StatusSelect";
import MyAwardMedal from './MyAwardMedal';
import LanguageSwitcher from "./LanguageSwitcher";
import UserMenu from "./UserMenu";
// import ThemeSwitcher from "./ThemeSwitcher";
import SystemNotification from "./SystemNotification";
import config from "../../../../config";
import MenuIcon from '../../../../assets/icons/MenuIcon';
import XIcon from '../../../../assets/icons/XIcon';
import './header.css';

const styles = {
    wrapper: {
        /*
         * Above the navigation panel, which is on 1201 and now sits under this
         * bar rather than beside it. Inline, because that is where the rest of
         * this element's position lives - a value in the stylesheet would lose
         * to it.
         */
        zIndex: 1300,
        position: 'fixed',
        width: '100%',
        top: 0,
        left: 0,
        WebkitBoxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        MozBoxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        boxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        padding: '12px 0',
    },
    headerContainer: {
        display: 'flex',
        gap: '10px',
        /*
         * The name starts on the same vertical line the navigation does - the
         * panel's own gutter plus its inner padding - so the two leftmost
         * pieces of text on the screen line up instead of missing each other
         * by a few pixels.
         */
        padding: '0 16px',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
    },
    /*
     * Which company you are working in, at the left of the bar.
     *
     * It was the name alone in 16px, which read as the title of the page rather
     * than as whose data is on it - and a bare line of text with nothing beside
     * it has no reason to be that size. A mark and the name together say it is
     * an identity; the name can then sit at the size everything else in the bar
     * is set in.
     *
     * Growing is what pushes the actions to the far edge.
     */
    identity: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--ds-spacing-md)',
        flexGrow: 1,
        minWidth: 0,
        margin: 0,
    },
    mark: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        /* the same pale brand the sidebar marks the current page with */
        backgroundColor: 'var(--ds-bg-brand-secondary)',
        color: 'var(--ds-text-brand-tertiary)',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: 1,
        textTransform: 'uppercase',
        overflow: 'hidden',
    },
    markImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    title: {
        minWidth: 0,
        color: 'var(--ds-text-primary)',
        fontSize: 'var(--ds-body-1-size)',
        fontWeight: 600,
        lineHeight: 'var(--ds-body-2-line)',
        letterSpacing: 'var(--ds-body-2-spacing)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
};

const Header = (props) => {
    const {user, company, mobileSidebarOpen, onToggleMobileSidebar} = props;
    const features =
        company && company.tariff && company.tariff.features
            ? company.tariff.features
            : [];
    return (
        <div className={'fade-in header'} style={styles.wrapper}>
            <div className="dashboard-header-container" style={styles.headerContainer}>
                <button
                    type="button"
                    className="dashboard-sidebar-control-button"
                    onClick={onToggleMobileSidebar}
                    aria-label={mobileSidebarOpen ? 'Close navigation' : 'Open navigation'}
                    aria-expanded={mobileSidebarOpen}
                    aria-controls="dashboard-navigation"
                >
                    {mobileSidebarOpen
                        ? <XIcon width={22} height={22}/>
                        : <MenuIcon width={22} height={22}/>}
                </button>
                <h1 className="dashboard-header-title" style={styles.identity}>
                    <span style={styles.title}>{company.name}</span>
                </h1>
                <div className="dashboard-header-actions" style={{display: 'flex', gap: '10px'}}>
                    {/* first in the row, before the notifications: it is the
                        only thing here that belongs to the person rather than to
                        the application. Only drawn for whoever has one. */}
                    <MyAwardMedal/>
                    {features.includes(config.features.SYSTEM_NOTIFICATIONS) && (
                        <SystemNotification user={user} company={company}/>
                    )}
                    {/* Dark mode is held back until the header, the sidebar and
                        the body have been gone through - put this line back to
                        turn it on again. Everything behind it is in place:
                        utils/Theme.js, the switcher beside this file, and the
                        :root[data-theme="dark"] block in styles/variables.css. */}
                    {/* <ThemeSwitcher/> */}
                    <LanguageSwitcher user={user}/>
                    <StatusSelect user={user}/>
                    <UserMenu user={user} company={company}/>
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    mobileSidebarOpen: PropTypes.bool,
    onToggleMobileSidebar: PropTypes.func,
};

Header.defaultProps = {
    mobileSidebarOpen: false,
    onToggleMobileSidebar: () => {},
};

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/index.jsx